// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"460":"bdc66635","764":"bdc66635"}[chunkId] + ".chunk.css";
};